import configuration from '../../../utilities/configuration';
import { BaseModel } from "sjs-base-model";
import SingleIsinReportModel from "../../../models/reports/singleIsin/SingleIsinReportModel";
import SingleIsinReportShortModel from "../../../models/reports/singleIsin/SingleIsinReportShortModel";
import SingleIsinReportMonthlySummaryModel from "../../../models/reports/singleIsin/SingleIsinReportMonthlySummaryModel";
import * as EffectUtility from "../../../utilities/EffectUtility";

export async function requestAllReports() {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsPath;
    return EffectUtility.getToModel(SingleIsinReportModel, endpoint);
}

export async function createReportOnBehalf(newReport) {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsPath;
    return EffectUtility.postToModel(BaseModel, endpoint, newReport, true, true);
}

export async function updateReport(reportId, updatedReport) {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsPath + "/" + reportId;
    return EffectUtility.putToModel(BaseModel, endpoint, updatedReport, true, true);
}
export async function requestUserReports(userId) {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsByUserPath + "/" + userId;
    return EffectUtility.getToModel(SingleIsinReportShortModel, endpoint);
}

export async function createUserReport(userId, newReport) {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsByUserPath + "/" + userId;
    return EffectUtility.postToModel(BaseModel, endpoint, newReport, true, true);
}

export async function requestUserReportsMonthlySummary(userId) {
    const endpoint = configuration.apiServer + configuration.apiSingleIsinReportsByUserPath + "/" + userId + "/monthlySummary";
    return EffectUtility.getToModel(SingleIsinReportMonthlySummaryModel, endpoint);
}
